import { RESET } from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default () => (dispatch) =>
    dispatch(multiTemplateReviewActions[RESET]());
